import { render } from "./ShareLinkFree.vue?vue&type=template&id=5a067661&scoped=true"
import script from "./ShareLinkFree.vue?vue&type=script&lang=js"
export * from "./ShareLinkFree.vue?vue&type=script&lang=js"

import "./ShareLinkFree.vue?vue&type=style&index=0&id=5a067661&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a067661"]])

export default __exports__